export const API_HOST = `${process.env.REACT_APP_API_HOST}`;
export const API_V1_BASE = `${API_HOST}${process.env.REACT_APP_API_V1_BASE}`;
export const CDN_HOST = process.env.REACT_APP_CDN_HOST;
